

export const couponTypeList: any = [
  {
    _id: 1,
    name: "Global",
  },
  {
    _id: 2,
    name: "Product Type",
  },
  {
    _id: 3,
    name: "Category",
  },
  {
    _id: 4,
    name: "Product",
  },
];

export const loginTypeList: any = [
  {
    _id: 1,
    name: "Main Panel",
  },
  {
    _id: 2,
    name: "Employee",
  },
]

export const paymentOptions = [
  { _id: 0, name: "DEFAULT (Without Coupon Code)" },
  { _id: 1, name: "IFAS COUPON CODE" },
  { _id: 2, name: "STUDENT" },
  { _id: 3, name: "EDUTECH COUNSELLOR" },
  { _id: 4, name: "PAMPHLET" },
  { _id: 5, name: "SHOPIFY" },
  { _id: 6, name: "PUBLICATION COUNSELLOR" },
];

export const ShipmentStatusList = [
  {
    _id: 0,
    name: "Pending",
  },
  {
    _id: 1,
    name: "Partial Dispatched",
  },
  {
    _id: 2,
    name: "Complete Dispatched",
  },
  {
    _id: 3,
    name: "Delivered",
  },
];
export const gstRateList = [
  {
    id: 1,
    name: "0",
  },
  {
    id: 2,
    name: "5",
  },
  {
    id: 3,
    name: "12",
  },
  {
    id: 4,
    name: "18",
  },
  {
    id: 5,
    name: "28",
  },
];
export const statusActiveDeactiveDeleted = [
  {
    _id: 1,
    name: "Active",
  },
  {
    _id: 9,
    name: "Deleted",
  },
];
export const tbpSourceList = [
  {
    _id: 1,
    name: "WEBSITE REGISTRATION",
  },
];
export const stockSellingType = [ 
  { _id: 1, name: "In House Two Brothers", value: "twobrothers-inhouse" },
  { _id: 2, name: "WareHouse Two Brothers", value: "twobrothers-warehouse" },
  { _id: 3, name: "In House Publication", value: "publication-inhouse" },
  { _id: 4, name: "WareHouse Publication", value: "publication-warehouse" },

];
export const stockShiftingType = [
  { _id: 1, name: "WareHouse Two Brothers", value: "twobrothers-warehouse" },
  { _id: 2, name: "In House Publication", value: "publication-inhouse" },
  { _id: 3, name: "WareHouse Publication", value: "publication-warehouse" },
];

export const stockReturnType = [
  { _id: 1, name: "Order return to" },
];
export const stockShiftType = [
  { _id: 1, name: "From In House Two Brothers" },
  { _id: 2, name: "Shift to In House Two Brothers" },
];

export const BookStatusList = [
  {
    _id: 0,
    name: "All",
  },
  {
    _id: 1,
    name: "Available",
  },
  {
    _id: 2,
    name: "Out Of Stock",
  },
];